import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';

export class DepositItemResultDto extends UserNameDisplayResultDto {
    itemId: number;
    itemSourceType: string;
    source: string;
    amount: number;
    description: string;
    payer: string;
    transactionNumber: string;

    @Type(() => Date)
    transactionDate: Date;

    @Type(() => Date)
    receivedDate: Date;

    @Type(() => Date)
    updatedTime: Date;
}
